import React from 'react';
import { Card, Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';
import "./EarningsStats.scss";
import { Skeleton } from 'antd-v5';

interface EarningDto {
  totalExpectedEarning: number | null;
  totalObtainedEarning: number | null;
  totalBookings: number | null;
}

interface EarningsResultDto {
  eventEarnings: EarningDto | null;
  lessonEarnings: EarningDto | null;
  courseEarnings: EarningDto | null;
  productEarnings: EarningDto | null;
}

interface TrainerDashboardProps {
  Earnings: EarningsResultDto | null;
}

const EarningsStats: React.FC<TrainerDashboardProps> = ({ Earnings }) => {
  const { t } = useTranslation();
  const barHeight = 250;

  const getValue = (value: number | null | undefined) => value ?? 0;

  const totalExpectedEarning =
    getValue(Earnings?.eventEarnings?.totalExpectedEarning) +
    getValue(Earnings?.courseEarnings?.totalExpectedEarning) +
    getValue(Earnings?.lessonEarnings?.totalExpectedEarning);

  const totalObtainedEarning =
    getValue(Earnings?.eventEarnings?.totalObtainedEarning) +
    getValue(Earnings?.courseEarnings?.totalObtainedEarning) +
    getValue(Earnings?.lessonEarnings?.totalObtainedEarning)+
    getValue(Earnings?.productEarnings?.totalObtainedEarning);

  const totalBookings =
    getValue(Earnings?.eventEarnings?.totalBookings) +
    getValue(Earnings?.courseEarnings?.totalBookings) +
    getValue(Earnings?.lessonEarnings?.totalBookings);

  const data = [
    // {
    //   label: t('totalEarnings'),
    //   expected: totalExpectedEarning,
    //   obtained: totalObtainedEarning,
    //   bookings: totalBookings,
    //   color: '#B266FF', // Purple
    // },
    {
      label: t('products'),
      expected: getValue(Earnings?.productEarnings?.totalExpectedEarning),
      obtained: getValue(Earnings?.productEarnings?.totalObtainedEarning),
      bookings: getValue(Earnings?.productEarnings?.totalBookings),
      color: '#C084FC', // Blue
    },
    {
      label: t('events'),
      expected: getValue(Earnings?.eventEarnings?.totalObtainedEarning),
      obtained: getValue(Earnings?.eventEarnings?.totalObtainedEarning),
      bookings: getValue(Earnings?.eventEarnings?.totalBookings),
      color: '#2563EB', // Blue
    },
    {
      label: t('courses'),
      expected: getValue(Earnings?.courseEarnings?.totalExpectedEarning),
      obtained: getValue(Earnings?.courseEarnings?.totalObtainedEarning),
      bookings: getValue(Earnings?.courseEarnings?.totalBookings),
      color: '#FF912D', // Orange
    },
    {
      label: t('trainings'),
      expected: getValue(Earnings?.lessonEarnings?.totalExpectedEarning),
      obtained: getValue(Earnings?.lessonEarnings?.totalObtainedEarning),
      bookings: getValue(Earnings?.lessonEarnings?.totalBookings),
      color: '#00A651', // Green
    },
  ];

  return (
    <Card className='earning-stats'>
      {/* <Skeleton active loading={Earnings!=null}> */}
      <h3>{t("last30DaysTotalEarnings") as string}</h3>
      <h3 className='total-earning'>{totalObtainedEarning} kr</h3>

      <div className='bars-container'>
        {data.map((item, index) => {
          const { expected, obtained, bookings, label, color } = item;
          const filledHeight = expected > 0 ? (obtained / expected) * barHeight : 0;

          return (
            <div key={index} className='bar-item'>
              <Tooltip
                // title={`Total earnings this month: ${obtained} kr, total bookings this month: ${bookings}`}
                title={t("totalEarningsTooltip",{obtained : obtained.toString(),bookings: bookings.toString()})}
              >
                <div className='bar-outer'>
                  <div
                    className='bar-filled'
                    style={{
                      minHeight:'fit-content',
                      height: filledHeight,
                      background: color,
                    }}
                  >
                    <span>{obtained} kr</span>
                  </div>

                  <div className='bar-top-text'>
                    {expected} kr
                  </div>

                  <div className='bar-bookings'>
                    {t("totalBookings")}: {bookings}
                  </div>
                </div>
              </Tooltip>
              <div className='bar-label'>{label}</div>
            </div>
          );
        })}
      </div>

      {/* Legend */}
      <div className='legend'>
        {data.map((item, idx) => (
          <div key={idx} className='legend-item'>
            <span
              className='legend-dot'
              style={{ background: item.color }}
            ></span>
            <span>{item.label}</span>
          </div>
        ))}
      </div>
      {/* </Skeleton> */}
    </Card>
  );
};

export default EarningsStats;
